import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const commitsAppBuilder = DataRouterApplicationBuilder.create('commits')
